export default __webpack_public_path__ + "static/media/midasi_point_vi_pc.76b77593.png";